import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import axios from "../axios";

export default function VerifyEmail() {
  const { user } = useAuth();
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Poll the backend to check if the email is verified
    const interval = setInterval(async () => {
      try {
        const response = await axios.get("/api/user");
        if (response.data.email_verified) {
          clearInterval(interval); // Stop polling once verified
          navigate("/"); // Redirect to dashboard
        }
      } catch (error) {
        console.error("Error checking email verification status:", error);
      }
    }, 5000); // Poll every 5 seconds

    return () => clearInterval(interval); // Cleanup on component unmount
  }, [navigate]);

  const handleResendEmail = async () => {
    setLoading(true);
    try {
      await axios.post("/email/verification-notification");
      setStatus("Το email επαλήθευσης στάλθηκε. Ελέγξτε τα εισερχόμενά σας.");
    } catch (error) {
      console.error("Error resending email verification:", error);
      setStatus("Αποτυχία αποστολής email επαλήθευσης. Δοκιμάστε ξανά.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <div className="w-full max-w-md bg-white p-6 rounded shadow-md text-center">
        <h1 className="text-2xl mb-4">Επαληθεύστε το Email σας</h1>
        <p className="mb-4">
        Γεια σου <strong>{user?.name}</strong>, στείλαμε ένα email στο{" "}
          <strong>{user?.email}</strong>. Ελέγξτε τα εισερχόμενά σας και κάντε κλικ στον σύνδεσμο επαλήθευσης για να συνεχίσετε.</p>
        {status && <div className="text-green-500 mb-4">{status}</div>}
        <button
          onClick={handleResendEmail}
          disabled={loading}
          className={`w-full bg-blue-500 text-white py-2 rounded ${
            loading ? "opacity-50 cursor-not-allowed" : "hover:bg-blue-600"
          } transition`}
        >
          {loading ? "Επαναποστολή..." : "Εκ νέου αποστολή email επαλήθευσης"}
        </button>
      </div>
    </div>
  );
}
